import React, { FC, MouseEventHandler } from 'react';

import AddIcon from '@material-ui/icons/AddCircle';
import { Theme, useMediaQuery } from '@material-ui/core';

import { EmptySpotStyled } from './EmptySpot.Styles';

interface IEmptySpotProps {
  onClick?: MouseEventHandler<HTMLDivElement>;
  editMode: boolean;
}

export const EmptySpot: FC<IEmptySpotProps> = props => {
  const { onClick, editMode } = props;

  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <EmptySpotStyled
      className="empty-spot"
      editMode={editMode}
      addPlayer={true}
      onClick={!!onClick && !smUp ? onClick : undefined}
      buttonMode={!!onClick && !smUp}
    >
      {editMode ? (
        smUp ? (
          <span>EMPTY SPOT</span>
        ) : (
          <>
            <AddIcon color="primary" />
            <span>ADD PLAYER</span>
          </>
        )
      ) : (
        'OPEN SPOT'
      )}
    </EmptySpotStyled>
  );
};
